<template>
    <div class="main-content " v-cloak>
        <div class="container landing">
            <div v-if="show_payment_modal">
                <payment-modal :price="total_sum" :shown="true" @close-modal="closePaymentModal"></payment-modal>
            </div>
            <div class="pricing-options">
                <div class="title">Choose a plan:</div>
                <div class="plans-container">
                    <div class="pricing-plan-container planner" style="margin-left:0;">
                        <div class="pricing-plan">
                            <div class="pricing-plan-content">
                                <div class="plan-title">Planner</div>
                                <div class="pricing-plan-price">
                                    <span class="pricing-plan-currency">€</span>4
                                    <span class="pricing-plan-cents">.99</span>
                                </div>
                                <div class="pricing-plan-price-text">per month</div>
                            </div>
                        </div>

                        <div class="pricing-list">
                            <ul>
                                <li>Create events</li>
                                <li>Add tasks</li>
                                <li>Invite people</li>
                                <li>Add budget</li>
                            </ul>
                        </div>
                        <!--
                        <a href="javascript:{}" class="btn-primary">SUBSCRIBE <span>€4.99/M</span></a>
                        <div class="trial">Free trial (30 days)</div>
                        -->
                    </div>

                    <div class="pricing-plan-container pro" style="margin-right:0;">
                        <div class="pricing-plan">
                            <div class="pricing-plan-content">
                                <div class="plan-title">Pro</div>
                                <div class="pricing-plan-price">
                                    <span class="pricing-plan-currency">€</span>
                                    14
                                    <span class="pricing-plan-cents">.99</span>
                                </div>

                                <div class="pricing-plan-price-text">per month</div>
                            </div>
                        </div>

                        <div class="pricing-list">
                            <div class="pricing-list-header">
                                All planner features +
                            </div>
                            <ul>
                                <li>Add expenses</li>
                                <li>Budget calculations</li>
                                <li>Create food menus</li>
                                <li>Create food menus</li>
                                <li>Food suggestions</li>
                                <li>Receipes</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="plans-container">
                    <div class="pricing-plan-container btn-wrapper" style="margin-left:0;">
                        <a @click="subscribe" href="javascript:{}" class="btn-primary"
                            >SUBSCRIBE <span>€4.99/M</span></a
                        >
                        <div v-if="user && !user.free_trial_used" class="trial">Free trial (30 days)</div>
                    </div>
                    <div class="pricing-plan-container">
                        <div class="coming">Coming soon</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PaymentModal from "./payment-modal";

export default {
    name: "subscription",
    components: { PaymentModal },
    data() {
        return {
            is_trial: true,
            show_payment_modal: false,
            total_sum: 0
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.get_logged_in_user();
            vm.get_pricing_plans();
            next();
        });
    },
    computed: {
        ...mapState(["user", "user_save_success"]),
        ...mapState(["pricing_plans", "client_token"])
    },
    methods: {
        ...mapActions(["delete_user", "get_logged_in_user", "add_free_trial"]),
        ...mapActions(["get_pricing_plans"]),
        closePaymentModal() {
            this.show_payment_modal = false;
        },
        subscribe() {
            if (!this.user.free_trial_used) {
                this.add_free_trial();
            } else {
                this.show_payment_modal = true;
            }
        }
    },
    mounted() {},
    created() {}
};
</script>
<style scoped>
@media (max-width: 82rem) {
    .main-content {
        padding: 3.2rem 1.6rem 0 1.6rem;
    }
}

.title {
    font-size: 3.4rem;
    line-height: 5rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    color: #000000;
    margin-top: 4.2rem;
    margin-bottom: 4.2rem;
}

@media (max-width: 820px) {
    .title {
        margin-top: 0;
        margin-bottom: 2.4rem;
        align-self: flex-start;
        font-size: 2rem;
        line-height: 2.4rem;
    }
}

@media (max-width: 820px) {
    .pricing-plan-price {
        font-size: 28px;
        line-height: 32px;
    }

    .pricing-plan-cents {
        font-size: 14px;
        line-height: 20px;
    }

    .pricing-plan-currency {
        font-size: 14px;
        line-height: 20px;
    }

    .pricing-plan-price-text {
        font-size: 11px;
        line-height: 16px;

        letter-spacing: 0.05em;
    }
}

.plans-container {
    display: flex;
    margin-bottom: 4rem;
    width: 100%;
    justify-content: center;
}

@media (max-width: 820px) {
    .plans-container {
        justify-content: initial;
    }
}

@media only screen and (max-width: 680px) {
    .landing .pricing-plan-container {
        padding: 0;
    }
}

.pricing-plan {
    box-shadow: none !important;
    margin-bottom: 2.4rem;
}

.coming {
    padding: 0.8rem 0;
    font-size: 1.4rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: 0.02em;
    color: #000000;
}

@media (max-width: 820px) {
    .coming {
        font-size: 12px;
        line-height: 24px;
    }
}

.pricing-list {
    font-size: 1.4rem;
    line-height: 2.4rem;
    letter-spacing: 0.02em;
}

.pricing-list-header {
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2.4rem;
    margin-bottom: 1.2rem;
}

@media (max-width: 820px) {
    .pricing-list {
        font-size: 1.2rem;
        line-height: 2.4rem;
        letter-spacing: 0.02em;
    }

    .pricing-list-header {
        font-weight: 600;
        font-size: 1.4rem;
        line-height: 2.4rem;
        margin-bottom: 0;
    }
}

.pricing-plan-content {
    box-shadow: none !important;
    border-top-left-radius: 0.4rem;
    border-bottom-left-radius: 0.4rem !important;
    border-top-right-radius: 0.4rem;
    border-bottom-right-radius: 0.4rem !important;
    min-height: 8.4rem;
    padding-top: 1.6rem;
}

.landing .pricing-plan-container {
    margin: 0 0.8rem 0rem 0.8rem;
}

.pricing-options {
    margin-left: 0;
    margin-right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.plan-title {
    font-size: 1.4rem;
    line-height: 2.8rem;
    text-align: center;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    font-weight: bold;
    color: #ffffff;
}

.btn-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
}

@media (max-width: 820px) {
    .plan-title {
        font-size: 1.1rem;
        line-height: 2.4rem;
    }
}

.btn-primary {
    padding: 0.8rem 1.6rem;
    font-size: 1.2rem;
    align-items: flex-start; /* NEW */
}

@media (max-width: 820px) {
    .btn-primary {
        font-size: 11px;
    }
}

.trial {
    font-size: 1.4rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: 0.03em;
    color: #717171;
    margin-top: 1.6rem;
}

@media (max-width: 820px) {
    .trial {
        font-size: 12px;
        line-height: 16px;
    }
}

@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}

.btn-primary span {
    margin-left: 0.4rem;
    font-weight: 400;
}
</style>
